import * as React from "react";
import Modal from "../../ui/modal/Modal";
import CreateFinanceProductForm from "../form/create/CreateFinanceProductForm";

interface IComponentProps {
	/**
	 * Close modal callback
	 */
	closeModal: () => void
}

export default class CreateFinanceProductModal extends React.Component<IComponentProps, {}> {
	render() {
		return (
			<Modal onCloseClicked={this.props.closeModal} title={"Create Finance Product"}>
				<CreateFinanceProductForm closeModal={this.props.closeModal}/>
			</Modal>
		);
	}
}
